import { Capacitor } from '@capacitor/core';

export const platform = {
  /** Running inside a native iOS/Android shell */
  isNative: Capacitor.isNativePlatform(),
  /** Specifically iOS */
  isIOS: Capacitor.getPlatform() === 'ios',
  /** Specifically Android */
  isAndroid: Capacitor.getPlatform() === 'android',
  /** Running in web browser (including PWA) */
  isWeb: Capacitor.getPlatform() === 'web',
  /** Running as installed PWA (standalone mode) */
  isPWA: !Capacitor.isNativePlatform() &&
         window.matchMedia('(display-mode: standalone)').matches,
} as const;
